<template>
    <div class="b1t-okraina-header">
        <div class="container">
            <div class="row mx-n1">
                <div class="col-auto px-1">
                    <div class="btn-icon"  v-ripple.300 @click="onBtnBackClick">
                        <span v-if="IS_MAIN_PAGE" class="b1t-fi b1t-fi-menu"></span>
                        <span v-if="!IS_MAIN_PAGE" class="b1t-fi b1t-fi-return"></span>
                    </div>
                </div>
                <div class="col logo-cell">
                    <img class="logo" alt="Окраина" :src=" require('../../assets/images/logo-mobile.svg') "  title="Окраина"/>
                </div>
                <div class="col-auto px-1">
                    <div class="btn-icon"  v-ripple.300>
                        <span class="b1t-fi b1t-fi-search"></span>
                    </div>
                </div>
                <div class="col-auto px-1">
                    <div class="btn-icon"  v-ripple.300>
                        <router-link :to="{name: 'cart', params: {}}">
                            <span class="b1t-fi b1t-fi-cart"></span>
                        </router-link>
                    </div>
                </div>
            </div>
        </div>
        
    </div>
</template>

<script>
    import {mapGetters} from 'vuex';

    export default {
        name: 'b1t-okraina-header',
        computed: {
            ...mapGetters([
                'IS_MAIN_PAGE'
            ])
        },
        methods: {
            onBtnBackClick() {
                if(this.IS_MAIN_PAGE) {
                    alert("menu");
                } else {
                    window.history.length > 1 ? this.$router.go(-1) : this.$router.push('main');
                }
            }
        }
    }
</script>

<style lang="scss">
    .b1t-okraina-header {
        background: #76B82B;
        color: #fff;
        padding: 5px 0px;
        position: fixed;
        top: 0px;
        left: 0px;
        right: 0px;
        z-index: 100;

        .logo-cell {
            text-align: center;
            
        }

        .btn-icon  {
            padding: 10px;
            cursor: pointer;
            font-size: 17px;
            display: inline-block;
            border-radius: 50%;
            line-height: 1;

            a {
                color: #fff;
                text-decoration: none;
                border-bottom: 0px;
            }
            
        }

        .logo {
            margin-top: 10px;
        }
    }
</style>